import React from "react";
import classNames from "classnames";
import classes from "./Notifications.module.css";
import { AgGridReact } from "@ag-grid-community/react";
import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";
import "@ag-grid-community/core/dist/styles/ag-grid.css";
import "@ag-grid-community/core/dist/styles/ag-theme-alpine.css";
import UTIL from '../../../../../util';
import ButtonsContent from "./ButtonContent";

// Icons
import newImg from "../../../../../assets/images/Fireboard/new.png";
import { NotificationType } from '../../../../../enums';
import FireboardUtils from "../../../../../util/fireboard-util";

const showGoAndDismiss = notification => {
  if (notification.notificationTypeId === NotificationType.NEW_ORDER) {
    return true;
  }
  return false;
};

let gridAPI;

const onGridReady = params => {
  gridAPI = params.api;
  params.api.sizeColumnsToFit();
}

const onGridSizeChanged = (params) => {
  params.api.sizeColumnsToFit();
}

const getOverlayNoRowsTemplate = () => {
  return `<span class="ag-overlay-loading-center">No notifications available</span>`;
};

const Notifications = ({ notificationsData = [], removeNewTag = () => { } }) => {
  const heightConstant = UTIL.round(window.innerHeight / 900);
  const widthConstant = UTIL.round(window.innerWidth / 1440);

  const notificationsColumnsDefs = [
    {
      headerName: "Type",
      field: "type",
      cellRendererFramework: ({ data: { sourceType = "" } }) => {
        return (
          <div className={classes.centerWithPadding}>
            <img
              src={FireboardUtils.getCheckSourceIcon(sourceType)}
              className={classes.iconSize}
              alt="mode"
            />
          </div>
        );
      },
      resizable: true,
      width: 100 * widthConstant,
    },
    {
      headerName: "",
      field: "isNew",
      cellRendererFramework: ({ data: { isNew } }) => {
        return isNew ? (
          <div className={classes.centerWithPadding}>
            <img src={newImg} className={classes.iconSize} alt="new" />
          </div>
        ) : null;
      },
      resizable: true,
      width: 100 * widthConstant,
    },
    {
      headerName: "Time",
      field: "time",
      width: 120 * widthConstant,
      cellClass: [`${classes.column}`],
      resizable: true,
    },
    {
      field: "message",
      width: 800 * widthConstant,
      headerName: "Message",
      resizable: true,
      cellRendererFramework: ({ data: { message, isNew } }) => {
        return (
          <div className={`${classes.centerWithPadding} ${classes.messageContainer}`}>
            <span
              className={classNames(`${classes.defaultMessageStyle}`, {
                [`${classes.newMessageStyle}`]: isNew,
              })}
            >
              {message}
            </span>
          </div>
        );
      },
    },
    {
      headerName: "Actions",
      field: "buttons",
      width: 310 * widthConstant,
      resizable: true,
      cellRendererFramework: ({
        data: {
          ack,
          dismiss,
          goAndDismiss,
          notificationGoAndDismiss,
          dismissNotification,
          ackNotification,
          acknowledgeIdCheck,
          // acknowledgeOverServe,
          notification,
          goToCheck,
          managerMode,
        },
      }) => {
        return (
          <ButtonsContent
            ack={ack}
            dismiss={dismiss}
            goAndDismiss={goAndDismiss}
            notificationGoAndDismiss={notificationGoAndDismiss}
            dismissNotification={dismissNotification}
            ackNotification={ackNotification}
            acknowledgeIdCheck={acknowledgeIdCheck}
            // acknowledgeOverServe={acknowledgeOverServe}
            notification={notification}
            showGoAndDismiss={showGoAndDismiss}
            goToCheck={goToCheck}
            managerMode={managerMode}
          />
        );
      },
    },
  ];

  return (
    <div className={`${classes.notifications}`}>
      <AgGridReact
        suppressRowTransform={true}
        onGridReady={onGridReady}
        onGridSizeChanged={onGridSizeChanged}
        columnDefs={notificationsColumnsDefs}
        rowData={notificationsData ? notificationsData : []}
        rowClass={classes.gridRowClass}
        rowHeight={70 * heightConstant}
        headerHeight={80 * heightConstant}
        modules={[ClientSideRowModelModule]}
        onRowClicked={({ data: { notification } }) =>
          removeNewTag(notification)
        }
        overlayNoRowsTemplate={getOverlayNoRowsTemplate()}
      />
    </div>
  );
};

export default Notifications;
